import React from 'react';
import config from 'config';
import './AppFooter.scss';

export class AppFooter extends React.Component {
  render() {
    const year = new Date().getFullYear();
    const version = `v${config.version}`;
    return (
      <div className='app-footer'>
        <div>
          {year} &copy; PerforMax {version}
          <br />
          powered by TenMax
          <br />
        </div>
      </div>
    );
  }
}
